import type { FC } from 'react';

import { humanize } from '@pesto/utils';

import { Badge } from '../../../components/Badge';
import { Typography } from '../../../components/Typography';

export interface CreditCheckReasonCodeGroup {
  category: string;
  codes: string[];
}

interface CreditCheckReasonCodesProps {
  reasonCodes?: (CreditCheckReasonCodeGroup | null)[] | null;
}

export const CreditCheckReasonCodes: FC<CreditCheckReasonCodesProps> = ({ reasonCodes }) => {
  const groups = reasonCodes?.filter((group): group is CreditCheckReasonCodeGroup => Boolean(group?.codes?.length));

  if (!groups?.length) return null;

  return (
    <div className="mt-4 space-y-3">
      <Typography variant="body" className="text-foreground/60 font-medium">
        Reason codes
      </Typography>
      {groups.map((group) => (
        <div key={group.category} className="space-y-1">
          <Typography variant="bodySmall" className="text-foreground/60">
            {humanize(group.category)}
          </Typography>
          <div className="flex flex-wrap gap-1">
            {group.codes.map((code) => (
              <Badge key={code} variant="outline">
                {code}
              </Badge>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
